module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.title) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Summary of errors, load failures, clinic matching, team tasks")]), _vm._v(" "), _c('hr', {
    staticClass: "titles-rule"
  }), _vm._v(" "), _c('div', {
    staticClass: "thumbnails"
  }, _vm._l((_vm.measures), function(measure) {
    return _c('div', {
      key: measure.id,
      staticClass: "dashboard-thumbnail-outer"
    }, [_c('dashboard-thumbnail', {
      attrs: {
        "measure": measure
      }
    })], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff08768c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/Dashboard.vue
// module id = 215
// module chunks = 5